module.exports = "/_next/static/images/icon-calendar-4361af068bd8a10da3a93ea88bc5b0b6.png";